import React from 'react';
import PropTypes from 'prop-types';
import ToggleSwitch from 'shared/components/ToggleSwitch';
import { wrapFormComponentWithLabelAndError } from './StyledFormComponentWrappers';

import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

const RawToggleSwitchInput = props => {
  const { name, ...otherInputProps } = props;
  return <ToggleSwitch name={name} id={name} checked={props.value} {...otherInputProps} />;
};

RawToggleSwitchInput.propTypes = {
  name: PropTypes.string.isRequired,
};

RawToggleSwitchInput.displayName = 'RawToggleSwitchInput';

const RawToggleSwitchField = wrapFormComponentWithLabelAndError(RawToggleSwitchInput);
RawToggleSwitchField.displayName = 'RawToggleSwitchField';

export { RawToggleSwitchField };

const ToggleSwitchField = connectFormComponentToReduxForm(RawToggleSwitchField, {
  normalize: value => !!value,
});
ToggleSwitchField.displayname = 'ToggleSwitchField';

export default ToggleSwitchField;
